import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RelatedServices = ({ services }) => {
  return (
    <div className="bg-card rounded-xl shadow-md border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-2xl font-semibold text-foreground">Related Services</h2>
        <p className="text-sm text-muted-foreground mt-1">You might also be interested in</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
        {services?.map((service) => (
          <Link
            key={service?.id}
            to={`/digital-service-standee?service=${service?.id}`}
            className="group bg-background rounded-lg border border-border overflow-hidden hover:shadow-lg transition-all duration-250"
          >
            <div className="relative h-48 overflow-hidden">
              <Image
                src={service?.image}
                alt={service?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-3 right-3">
                <span className="px-2 py-1 rounded-full text-xs font-semibold bg-accent text-accent-foreground">
                  {service?.badge}
                </span>
              </div>
            </div>

            <div className="p-4">
              <h3 className="font-semibold text-foreground mb-2 truncate-2 group-hover:text-primary transition-colors">
                {service?.name}
              </h3>
              <p className="text-sm text-muted-foreground mb-3 truncate-2">
                {service?.description}
              </p>

              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1">
                  <Icon name="Star" size={14} className="text-accent fill-accent" />
                  <span className="text-sm font-semibold text-foreground">{service?.rating}</span>
                  <span className="text-xs text-muted-foreground">({service?.reviews})</span>
                </div>
                <div className="text-sm font-semibold text-foreground">
                  From ${service?.priceStart}
                </div>
              </div>

              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={12} />
                  <span>{service?.timeline}</span>
                </div>
                <span>•</span>
                <div className="flex items-center gap-1">
                  <Icon name="Users" size={12} />
                  <span>{service?.providers} providers</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedServices;